import React from 'react';
export function Footer() {
  return <footer className="py-12 border-t border-gray-100 bg-white" data-id="element-32">
      <div className="container mx-auto px-6 flex flex-col md:flex-row justify-between items-center" data-id="element-33">
        <div className="flex items-center space-x-2 mb-4 md:mb-0" data-id="element-34">
          <div className="w-4 h-4 bg-[#84cc16]" data-id="element-35" />
          <span className="font-bold tracking-tight text-lg" data-id="element-36">Joueurlibre</span>
        </div>

        <div className="text-sm text-gray-500 font-medium" data-id="element-37">
          Warszawa, Poland · © 2026 Joueurlibre. All rights reserved.
        </div>
      </div>
    </footer>;
}